<template>
  <!-- 扫码上传入库资料 — 입고 때 박스 입고자료(사진)를 폰으로 연속 올리는 QR 을 메뉴에서 바로 연다(2026-10-18 杨英文 #82).
       入库列表 의 «扫码上传入库资料» 버튼과 같은 세션 QR 이다 -->
  <div class="container-fluid">
    <b-card>
      <h5 class="mb-3">扫码上传入库资料<small class="text-muted ml-1">(박스 입고자료 폰 업로드)</small></h5>
      <div v-if="loading" class="text-center my-4"><b-spinner variant="primary"></b-spinner></div>
      <div v-else-if="qr" class="text-center">
        <img :src="qr" alt="QR" style="width:280px;max-width:100%">
        <div class="mt-2">用手机相机扫描 → 扫箱子标签条码 → 拍摄入库资料 → 下一个箱子 … → 最后点「完成」<br>
          <span class="small text-muted">(폰으로 스캔 → 박스 라벨 바코드 → 입고자료 촬영 → 다음 박스 … → 마지막에 「완료」)</span></div>
        <div class="small text-muted mt-1">每箱自动识别入库ID·日期·中心, 结果在「箱子入库资料」页面查看(박스마다 자동 판독, 결과는 «箱子入库资料» 화면에서 확인)</div>
        <div class="mt-3">
          <b-button size="sm" variant="outline-primary" @click="load">↻ 重新生成QR<small>(QR 다시 만들기)</small></b-button>
          <router-link :to="{ name: 'logis.boxphotostatus' }" class="btn btn-sm btn-outline-secondary ml-2">箱子入库资料<small>(결과 보기)</small></router-link>
        </div>
      </div>
      <div v-else class="text-center text-danger">{{ error }}</div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import qrcode from 'qrcode-generator';

export default {
  name: 'BoxPhotoScan',
  data() {
    return { loading: false, qr: '', error: '' };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = '';
      try {
        const { data } = await axios.post('/api/boxPhoto/session');
        if (data.요청결과 !== '성공' || !data.token) throw new Error((data.error && data.error.errorMessage) || '');
        const q = qrcode(0, 'M');
        q.addData(window.location.origin + '/pages/import-photo-session?t=' + data.token);
        q.make();
        this.qr = q.createDataURL(8, 2);
      } catch (e) {
        console.error('입고자료 연속 업로드 QR 만들기 실패:', e);
        this.error = 'QR 生成失败(QR 생성 실패): ' + e.message;
        this.qr = '';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
